import React from 'react'
import {Layout} from 'antd'
import "./style/style.css"
import {Link} from "react-router-dom";

const {Footer} = Layout;

const MainFooter = () => {

    return (
        <>
            <Footer id="footer">
                <p id="footer-credits" className='footer-items'>ViLMedic - MIT License | <Link to={"/privacy"}>Privacy
                    Policy & Terms of Use</Link></p>
            </Footer>

        </>
    )
}

export default MainFooter
